import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { AuthSessionRepository } from '../repositories/AuthSessionRepository';
import { emit, events } from 'elc-service-bus';

export class TokenChangedUseCase {
    private authSessionRepository: AuthSessionRepository;

    constructor() {
        this.authSessionRepository = diContainer.get(serviceNames.authSessionRepository);
    }

    public execute = async () => {
        const { handleTokenStorage, authSession } = this.authSessionRepository;
        await handleTokenStorage();
        if (authSession.isAuthenticated) {
            void emit(events.AUTH_SUCCEDED, this.authSessionRepository.authSession.authSourceData);
        }
    };
}
